var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[_c('piv-entete',{on:{"basculeAfficherMenu":function($event){_vm.afficherMenu = !_vm.afficherMenu}}}),_c('v-main',[_c('AlerteErreur',{model:{value:(_vm.erreur),callback:function ($$v) {_vm.erreur=$$v},expression:"erreur"}}),_c('router-view')],1),_c('piv-pied-page')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }